import React from "react";
import "./Common_Heading_Round_holder.css";

function Common_Heading_Round_holder({headingText}) {
  return (
    <>
      <section className="Common_Heading_Round_holder">
        <h4>{headingText}</h4>
      </section>
    </>
  );
}

export default Common_Heading_Round_holder;
